import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.51 18.872l6.626-5.598.193-.158 1.637 1.491c.284.258.647.389 1.012.395.381.006.764-.125 1.06-.395l1.637-1.491.193.158 6.623 5.597A.995.995 0 0 1 21 19H3a.995.995 0 0 1-.49-.128zM2.306 5.281A.997.997 0 0 1 3 5h18c.27 0 .515.107.695.28l-9.331 8.588a.56.56 0 0 1-.728 0l-9.33-8.587zM2 6.353l6.571 6.076-.071.071L2 18V6.353zM22 18l-6.5-5.5-.071-.071L22 6.353V18z"
});

var SvgEmailFilled = function SvgEmailFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgEmailFilled;